import React, { FC } from 'react';

import { RenderElementProps } from 'slate-react';

import styled from 'styled-components';

//models
import { DatasetElement } from '../../../../models/editor.model';

import DatasetIconDropDown from './DatasetIconDropDown';
// components
import ZeroWidthSpace from './ZeroWidthSpace';

type DatasetElementProps = RenderElementProps & {
    element: DatasetElement;
    selectedElement?: { [key: string]: any };
    editDataset: (
        id: string,
        data: { datasetId: number; datasetField: number },
    ) => void;
};

const DatasetElementComponent: FC<
    React.PropsWithChildren<DatasetElementProps>
> = ({ children, element, selectedElement, attributes, editDataset }) => {
    return (
        <Container {...attributes}>
            <DatasetIconDropDown
                handleDatasetFieldClick={(id) => {
                    editDataset(selectedElement!.elementId, {
                        datasetId: element?.datasetId!,
                        datasetField: id,
                    });
                }}
                element={element}
            />

            <ZeroWidthSpace />
            {children}
            <ZeroWidthSpace />
        </Container>
    );
};

export default DatasetElementComponent;

const Container = styled.span({
    userSelect: 'none',
    outline: 'none',
    display: 'inline-flex',
    borderRadius: 'none',
});
